import React from 'react';
import { cn } from '../../utils/cn';

// Data table building blocks. Every list page uses these, so the table look (header, row
// dividers, hover, dark mode) is defined here once. Cells (<td>) stay plain elements because
// each column formats its own content.

export function Table({ className, children, ...props }) {
    return (
        <table className={cn('min-w-full divide-y divide-slate-200 dark:divide-slate-800', className)} {...props}>
            {children}
        </table>
    );
}

export function THead({ className, children, ...props }) {
    return (
        <thead className={cn('bg-slate-50/80 dark:bg-slate-800/40', className)} {...props}>
            {children}
        </thead>
    );
}

export function TBody({ className, children, ...props }) {
    return (
        <tbody className={cn('divide-y divide-slate-100 bg-white dark:divide-slate-800 dark:bg-slate-900', className)} {...props}>
            {children}
        </tbody>
    );
}

const ALIGN = { left: 'text-left', right: 'text-right', center: 'text-center' };

export function Th({ align = 'left', className, children, ...props }) {
    return (
        <th
            scope="col"
            className={cn(
                'whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400',
                ALIGN[align],
                className
            )}
            {...props}
        >
            {children}
        </th>
    );
}

export function Tr({ className, children, ...props }) {
    return (
        <tr className={cn('transition-colors duration-150 hover:bg-slate-50/80 dark:hover:bg-slate-800/40', className)} {...props}>
            {children}
        </tr>
    );
}
